<template>
    <div>
        <b-form-group
                :label="field.label"
                :label-for="field.key"
                :class="{
                'required-field': !!field.isRequired && !field.isDocType,
            }"
        >
            <b-form-select
                    :ref="field.key"
                    v-model="model"
                    v-validate="{
                    required: !!field.isRequired && !field.isDocType,
                }"
                    class="form-control"
                    :options="field.options"
                    :disabled="loading || disabled"
                    :data-vv-name="field.label"
                    :class="{
                    'is-invalid': errors.has('document type'),
                }"
            >
                <option slot="first" :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>
<script>
    import Dropdown from './Dropdown.vue'
    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > extends
        |--------------------------------------------------------------------------
        */
        extends: Dropdown, // End of Component > extends

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                model: null,
        
            }
        }, // End of Component > data

        props: {
            field: {
                type: Object,
                required: true,
            },
            dataSegmentId: {
                type: String,   
                required: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        }, // End of Component > mounted


        computed:{
           cardType() {
            return this.$store.getters.getField('identityInfo.cardType')
           },
        },
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
            model(value) {
                if(this.field && this.field.key == 'addressProofDocumentType'){
                    this.$store.commit('setValue', {
                    key: this.field.key,
                    value:value,
                    })
                    this.$store.commit('updateField', {
                    key: 'documentInfo.fieldAddressProof.addressProofDocumentType',
                    value:value,
                    })
                }else{
                    this.$store.commit('updateField', {
                    key: this.field.key,
                    value:value,
                   })
                }
                
            },
            cardType(value){
                if(value=='license' && this.field.key  == 'addressProofDocumentType'){
                        this.model = null
                    }
            }
        }, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        async mounted() {
        }, // End of Component > watch
    }
</script>
